import type { ToolResultBlock, ToolUseBlock } from '../../store/chatStore';
import type { ToolResultRegistry } from './types';
import { DefaultRenderer } from './renderers/DefaultRenderer';
import { AssetsTableRenderer } from './renderers/AssetsTableRenderer';
import { FindingsTableRenderer } from './renderers/FindingsTableRenderer';
import { RisksTableRenderer } from './renderers/RisksTableRenderer';
import { VulnerabilitiesTableRenderer } from './renderers/VulnerabilitiesTableRenderer';
import {
  MarkdownRenderer,
  extractMarkdownFromToolUse,
} from './renderers/MarkdownRenderer';
import { MovedOutputRenderer } from './renderers/moved-output-renderer';
import { readMovedToolOutput } from './moved-tool-output';

export const toolResultRenderers: ToolResultRegistry = [
  {
    // First: output Pleri moved out of the conversation is a note, not data.
    name: 'MovedOutputRenderer',
    component: MovedOutputRenderer,
    canHandle: (result: ToolResultBlock) =>
      readMovedToolOutput(result.content) !== undefined,
  },
  {
    name: 'MarkdownRenderer',
    component: MarkdownRenderer,
    canHandle: (result: ToolResultBlock, toolUse?: ToolUseBlock) => {
      if (!toolUse) {
        return false;
      }
      return extractMarkdownFromToolUse(toolUse) !== undefined;
    },
  },
  {
    name: 'AssetsTableRenderer',
    component: AssetsTableRenderer,
    canHandle: (_result: ToolResultBlock, toolUse?: ToolUseBlock) => {
      return toolUse?.name === 'listAssets';
    },
  },
  {
    name: 'FindingsTableRenderer',
    component: FindingsTableRenderer,
    canHandle: (_result: ToolResultBlock, toolUse?: ToolUseBlock) => {
      return (
        toolUse?.name === 'listFindings' || toolUse?.name === 'listAttackPaths'
      );
    },
  },
  {
    name: 'RisksTableRenderer',
    component: RisksTableRenderer,
    canHandle: (_result: ToolResultBlock, toolUse?: ToolUseBlock) => {
      return toolUse?.name === 'listRisks';
    },
  },
  {
    name: 'VulnerabilitiesTableRenderer',
    component: VulnerabilitiesTableRenderer,
    canHandle: (_result: ToolResultBlock, toolUse?: ToolUseBlock) => {
      return toolUse?.name === 'listVulnerabilities';
    },
  },
];

export const getRenderer = (
  result: ToolResultBlock,
  toolUse?: ToolUseBlock,
) => {
  const renderer = toolResultRenderers.find((r) =>
    r.canHandle(result, toolUse),
  );
  return renderer?.component || DefaultRenderer;
};
